import React from 'react';
import { Facebook, Phone, Mail } from 'lucide-react';
const PHONE = '586-203-3701';
const EMAIL = 'MoceriRS@gmail.com';
export function TopBar() {
  return <div className="w-full bg-[#3a3a3a] text-white text-sm" data-id="element-339" data-mp="234zyx3hxiae5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center justify-between gap-2" data-id="element-340" data-mp="1y4vhnb975bmv">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-341" data-mp="1t6ag98i7klwu">
          <Facebook className="w-4 h-4 text-[#2DB8E0]" data-id="element-342" data-mp="2lu6h8pet8zzf" />
          <span className="font-medium" data-id="element-343" data-mp="2h1wjwobd8xn4">Follow Us On FB</span>
        </a>
        <div className="flex items-center gap-6" data-id="element-344" data-mp="2c3leqqw0nbb8">
          <a href={`tel:${PHONE.replace(/-/g, '')}`} className="hidden sm:flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-345" data-mp="2c324zxgirt8a">
            <Phone className="w-4 h-4 text-[#2DB8E0]" data-id="element-346" data-mp="34rz8gug2nlgz" />
            <span className="font-medium" data-id="element-347" data-mp="34qfu59dz7khu">{PHONE}</span>
          </a>
          <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-348" data-mp="25re1ozahzvh">
            <Mail className="w-4 h-4 text-[#2DB8E0]" data-id="element-349" data-mp="3ol29lrh47a8p" />
            <span className="font-medium" data-id="element-350" data-mp="3okk5y9s4htqr">{EMAIL}</span>
          </a>
        </div>
      </div>
    </div>;
}